<template>
    <div v-loading="loading">
        <el-form ref="processFrom" :model="processFrom" label-width="80px">
            <el-form-item label="制法">
                <el-cascader v-model="processFrom.processingValue" :show-all-levels="false" :options="options"
                    @change="cascaderChange"></el-cascader>
            </el-form-item>
            <el-form-item label="袋数" v-if="processFrom.processingValue[0] == '熬药'">
                <span>每付</span>
                <el-input type="text" 
                    v-model.trim="processFrom.bagNum" maxlength="5" @change="bagNumberChange"></el-input>
                <span>袋，</span>
                <span>共</span>
                <el-input type="text" v-model.trim="processFrom.bagNumSum" maxlength="5" @change="bagNumSumChange"></el-input>
                <!-- {{ processFrom.bagNumSum }} -->
                <span>袋</span>
            </el-form-item>
            <el-form-item label="加工费">
                <span>¥</span>
                <el-input @input="updateDataNum($event, processFrom.processPrice )" v-model.trim="processFrom.processPrice" readonly></el-input>
            </el-form-item>
        </el-form>
    </div>
</template>
  
<script>
import { processingPrice } from "@/api/processing"; // 获取加工请求
import { positiveInteger,positiveNum2,positiveNum } from '@/utils/regexp'
import { validParams, isNull } from '@/utils/validateBase';
export default {
    // 定义引入的组件
    components: {},
    props: {
        //加工对象
        newProcessFrom: Object,
        //重量
        weight: String | Number,
        // 付数
        doseNum: String | Number
    },
    data() {
        return {
            processFrom: {
                processingValue: [],
                bagNum: '',
                bagNumSum: '',
                processPrice: '',
                processName: ''
            },
            options: [
                {
                    value: '熬药',
                    label: '熬药',
                },
                {
                    value: '制膏',
                    label: '制膏',
                },
                {
                    value: '制丸',
                    label: '制丸',
                    children: [
                        {
                            value: '蜜丸',
                            label: '蜜丸',
                        },
                        {
                            value: '水丸',
                            label: '水丸',
                        },
                    ]
                },
                {
                    value: '制粉',
                    label: '制粉',
                    children: [
                        {
                            value: '粗粉',
                            label: '粗粉',
                        },
                        {
                            value: '细粉',
                            label: '细粉',
                        },
                    ]
                },
                {
                    value: '加工-YL',
                    label: '加工-YL',
                    disabled: true,
                },

            ],
            loading: false
        }
    },
    //变量监听
    watch: {
    },
    // 页面初始化
    created() {
        this.processFrom = this.newProcessFrom
        console.log('this.processFrom', this.processFrom);
        if(isNull(this.processFrom.processPrice))this.getProcessingPrice()
    },
    // 页面DOM加载完成
    mounted() { },
    //离开页面时执行
    destroyed() { },
    // 页面方法
    methods: {
          /**
         * 加工费改变
         */
         updateDataNum: _.debounce(function (val, obj) {
            let bol = validParams(val, positiveNum, '请输入数字,保留两位小数,长度不能超过6位')
            if (bol) {

            } else {
                this.processFrom.processPrice = ''
            }
        }, 400),
        /**
         * 获取加工费
         */
        getProcessingPrice() {
            this.loading = true;
            let { bagNumSum, processName } = this.processFrom
            let params = {
                number: this.doseNum || 1,
                processingType: processName,
                weight: this.weight,
                // bagNumber: Utils.bigNumber(bagNumber, '*', this.doseNumber)
                bagNumberSum: bagNumSum
            }
            if (processName != '熬药') params.bagNumber = '0'
            processingPrice(params).then(res => {
                if (res.code == 200) {
                    this.loading = false
                    this.processFrom.processPrice = res.data || 0
                }
            })
        },
        /**
         * 输入框改变
         */
        bagNumberChange(val) {
            let bol = validParams(this.processFrom.bagNum, positiveNum2, '请输入正确的正数，最多2位小数')
            if (bol) {
                this.processFrom.bagNumSum =Math.ceil(this.$bigNumber(this.processFrom.bagNum, '*', (this.doseNum || 1))) //向上取整
                this.getProcessingPrice()
            } else {
                this.processFrom.bagNum = 3
            }
            // this.processFrom.bagNumSum = this.$bigNumber(this.processFrom.bagNum, '*', (this.doseNum || 1))
            this.getProcessingPrice()
        },
        /**
         * 选择器改变
         */
        cascaderChange(val) {
            let length = val.length
            let processName = val[length - 1]
            this.processFrom.processName = processName
            if (processName == '熬药') {
                this.processFrom.bagNum = '3'
                this.processFrom.bagNumSum = this.$bigNumber(this.processFrom.bagNum, '*', (this.doseNum || 1))
            } else {
                this.processFrom.bagNum = '0'
                this.processFrom.bagNumSum = '0'
            }
            this.getProcessingPrice()
        },
        /**
       * 总袋数改变
       */
        bagNumSumChange(val) {
            if (isNull(val)){
                this.$message.error('总袋数不能为空')
                return;
            }
            let bol = validParams(this.processFrom.bagNumSum, positiveInteger, '请输入正整数,不能超过6位')
            if (bol) {
                this.processFrom.bagNum = this.$bigNumber(this.processFrom.bagNumSum, '/', this.doseNum, 2)
                this.getProcessingPrice(this.processFrom, this.doseNum, this.processFrom.weight)
            } else {
                this.processFrom.bagNumSum=''
                // this.processFrom.bagNum = this.$bigNumber(this.processFrom.bagNum, '*', this.doseNum)
            }
            // this.getProcessingPrice()
        },
    },
}
</script>
<style lang="less" scoped>
.el-input {
    width: 80px;

    /deep/.el-input__inner {
        border: none;
        padding: 0;
        border-bottom: 1px solid #E1E1E1;
        text-align: center;

    }
}
</style>